export default "__VITE_ASSET__DFS6LhiJ__"